import { initializeApp } from 'firebase/app';

const firebaseConfig = {
  apiKey: "AIzaSyDbJKHj7KgOSzE00Mp40LkkbsYGLEWp-Rw",
authDomain: "productverification-225ba.firebaseapp.com",
projectId: "productverification-225ba",
storageBucket: "productverification-225ba.firebasestorage.app",
messagingSenderId: "1023914761795",
appId: "1:1023914761795:web:a15ba31b2af3eb9d3ffef6",
measurementId: "G-HRJR7C0EX3"
};

const app = initializeApp(firebaseConfig);

export default app;
